export const GET_FORM_ONE = 'GET_FORM_ONE'
export const UPDATE_FORM_ONE = 'UPDATE_FORM_ONE'
export const DELETE_FORM_ONE = 'DELETE_FORM_ONE'

